module.exports = __webpack_public_path__ + "static/media/new_referral_notification.ad78033a.svg";